import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Snackbar, TableCell } from '@material-ui/core'
import { Table, TableBody, TableHead, TableRow } from '@material-ui/core'
import moment from 'moment'
import { getUser } from '../../actions/users'
import { newTeam, getTeam } from '../../actions/teams'
import Navigation from '../../components/navigation'
import Breadcrumbs from '../../components/breadcrumbs'
import './styles.css'

class Teams extends Component {
  constructor (props) {
    super(props)
    this.handleTeamSelected = this.handleTeamSelected.bind(this)
    this.state = {
      newTeamName: '',
      loading: false
    }
  }

  componentDidMount () {
    this.updateData()
  }

  render () {
    const user = this.props.users[this.props.userId]
    const userTeams = ((user || {}).teams || [])
      .map(teamId => this.props.teams[teamId])
      .filter(team => (typeof team !== 'undefined'))
      .sort((a, b) => a.created - b.created)
      .map(team => this.createTableRow(team))

    return (
      <div className='scenes-teams'>
        <Navigation title='Teams'/>
        <Breadcrumbs config={[{ url: '/', title: 'Dashboard' }, { title: 'Teams' }]} />
        <div className='box'>
          <div className='section'>
            <div className='section-title'>Your Teams</div>
            <small className="form-text text-muted">
              If you would like to start a new team, go to our website and register for an available stage.
              You can do this by clicking <a href='https://runthemarenostrum.com/register.html'>this link</a>.
              If you like to join an existing team, please contact one of the team members and ask them
              to send you an invite.
            </small>
            {(userTeams.length > 0) && (
              <div className='teams-list'>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Member</TableCell>
                      <TableCell>Created</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {userTeams}
                  </TableBody>
                </Table>
              </div>
            )}
            {(userTeams.length === 0 && this.state.loading === false) && (
              <div className='section'>
                <div className='alert alert-primary' role='alert'>
                  No teams are linked to your account.
                </div>              
              </div>
            )}
          </div>
        </div>
        <Snackbar 
          open={this.state.loading}
          message={'Loading your teams...'}
          autoHideDuration={4000}
          onClose={() => this.setState({ loading: false })} />
      </div>
    )
  }

  handleTeamSelected (teamId) {
    this.props.history.push(`/team/${teamId}`)
  }

  createTableRow (team) {
    const created = new Date(parseInt(team.created, 10))
    return (
      <TableRow key={team.teamId} hover onClick={() => this.handleTeamSelected(team.teamId)} style={{cursor:'pointer'}}>
        <TableCell>{team.name}</TableCell>
        <TableCell>{team.members.length}</TableCell>
        <TableCell>{moment(created).fromNow()}</TableCell>
      </TableRow>
    )
  }

  updateData () {
    this.setState({ loading: true })
    return this.props.getUser(this.props.userId).then(() => {
      const user = this.props.users[this.props.userId]
      if (user && user.teams) {
        let teamsToLoad = user.teams.length
        user.teams.forEach(teamId => {
          this.props.getTeam(teamId).then(() => {
            teamsToLoad--
            if (teamsToLoad === 0) {
              this.setState({ loading: false })              
            }
          }).catch(() => {
            this.setState({ loading: false })
          })
        })
      } else {
        this.setState({ loading: false })        
      }
    })
  }
}

const mapDispatch = (dispatch) => {
  return {
    getUser: (userId) => getUser(userId)(dispatch),
    getTeam: (teamId) => getTeam(teamId)(dispatch)
  }
}

const mapState = (state) => ({ 
  teams: (state.teams.list || {}),
  users: (state.users.list || {}),
  userId: state.cognito.userId
})

export default connect(mapState, mapDispatch)(withRouter(Teams))
